module.exports = __webpack_public_path__ + "static/media/muscle_back_13.2a278d59.png";